import { SICKNESS } from 'common/domain/constants';
import { ICON_APPROVED_HTML, ICON_REQUESTED_HTML, DIV_ALWAYS_PAINT, DIV_LAST_DAY } from './calendar.templates';
import moment from 'moment';

const APPROVED = 'approved';
const SHOULD_PAINT_ALWAYS = 1;

function getHTML(day, status, isIconDay, iconDays, rangeEnd, type, code) {
  rangeEnd = moment(rangeEnd).format('YYYY-MM-DD');
  const isSickChecker = _checkIfIsSickness(rangeEnd, day, code);
  return _buildHtml(isIconDay, day, status, rangeEnd, iconDays, isSickChecker);
}

function _checkIfIsSickness(rangeEnd, day, code) {
  const today = new Date();
  const isSickness = SICKNESS.CODES.indexOf(code) > -1;
  const rangeEndIsToday = rangeEnd === moment(today).format('YYYY-MM-DD') && day.format('YYYY-MM-DD') === moment(today).format('YYYY-MM-DD');
  return isSickness && rangeEndIsToday;
}

function _buildHtml(isIconDay, day, status, rangeEnd, iconDays, isSickChecker) {
  let htmlEndDate = _getPaintCase(day, rangeEnd, iconDays, isSickChecker);
  day = day.format('DD');
  let html;
  if (isIconDay) {
    html = _paintIcon(status, day);
  } else {
    html = day;
  }
  return htmlEndDate + html;
}

function _getPaintCase(day, rangeEnd, iconDays, isSickChecker) {
  const ALWAYS_PAINT_CASE = _caseShouldAlwaysPaint(iconDays, day, isSickChecker);
  return day._d.getTime() === moment(rangeEnd)._d.getTime() ? ALWAYS_PAINT_CASE && !isSickChecker ? DIV_LAST_DAY : DIV_ALWAYS_PAINT : '';
}

function _paintIcon(status, date) {
  const iconHtml = (status === APPROVED) ? ICON_APPROVED_HTML : ICON_REQUESTED_HTML;
  return date + iconHtml;
}

function _caseShouldAlwaysPaint(iconDays, day, isSickChecker) {
  if (isSickChecker) return true;
  let count = getIconDayRepeated(iconDays, day);
  return count === SHOULD_PAINT_ALWAYS;
}

function getIconDayRepeated(iconDays, day) {
  let count = 0;
  iconDays.forEach((dayToCompare) => {
    if (day._d.getTime() === dayToCompare.getTime()) {
      count++;
    }
  });
  return count;
}

export {
  getHTML
};



// WEBPACK FOOTER //
// ./client/app/common/utils/calendarRenderLibrary/calendarRender.js